import { autocatalogConstants } from '../constants';
import { autocatalogService } from '../services';

export const autocatalogActions = {
  brands,
  models,
};

function models(brand) {
  return dispatch => {
    dispatch(request());

    autocatalogService.models(brand)
      .then(
        models => dispatch(success(models)),
        error => {
          dispatch(failure(error))
        }
      );
  };

  function request() { return { type: autocatalogConstants.FETCH_MODELS_REQUEST } }
  function success(models) { return { type: autocatalogConstants.FETCH_MODELS_SUCCESS, models } }
  function failure(error) { return { type: autocatalogConstants.FETCH_MODELS_FAIL, error } }
}


function brands() {
  return dispatch => {
    dispatch(request());

    autocatalogService.brands()
      .then(
        brands => dispatch(success(brands)),
        error => {
          dispatch(failure(error))
        }
      );
  };

  function request() { return { type: autocatalogConstants.FETCH_BRANDS_REQUEST } }
  function success(brands) { return { type: autocatalogConstants.FETCH_BRANDS_SUCCESS, brands } }
  function failure(error) { return { type: autocatalogConstants.FETCH_BRANDS_FAIL, error } }
}



// WEBPACK FOOTER //
// ./src/actions/autocatalog.actions.js